export const STATUS_COMPONENTE = {
  ATIVO: 1,
  DESCONTINUADO: 2,
} as const;

export const COR_DESCONTINUADO = '#D32F2F';
